import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalVariable } from '../helpers/settings';
import { RefreshVerificationService } from './refresh-verification.service';
import { PaginationOption } from '../models/pagination.model';
import { Result } from '../models/general';
import { CapConfig, CashJournalModel } from '../models/cash-book';

export interface PaginationData {
	docs: CashJournalModel[];
	total: number;
	limit: number;
	page: number;
	pages: number;
}

@Injectable({
	providedIn: 'root'
})
export class CashJournalModelService {
	readonly BASE_URL = `${GlobalVariable.server.host}/cash-journal-model`;

	constructor(private httpClient: HttpClient, private refreshVerifService: RefreshVerificationService) {}

	/****   --------------------------   ****/

	findCashJournalModelsByProject(projectId: string): Observable<CashJournalModel[]> {
		return this.refreshVerifService.buidResult(
			this.httpClient.get<CashJournalModel[]>(`${this.BASE_URL}/find/${projectId}`)
		);
	}

	editCashJournalModelConfig(model: string, config: Partial<CapConfig>): Observable<CashJournalModel> {
		return this.refreshVerifService.buidResult(
			this.httpClient.put<CashJournalModel>(`${this.BASE_URL}/config/edit`, { model, config })
		);
	}

	/****   --------------------------   ****/

	find(
		fromAppComponent: boolean,
		route: string,
		projectId: string,
		attributes: string = null
	): Observable<Partial<CashJournalModel[]>> {
		let params;
		if (fromAppComponent) {
			params = new HttpParams()
				.set('fromAppComponent', fromAppComponent)
				.set('componentRoute', route)
				.set('projectId', projectId);
		} else {
			params = new HttpParams().set('fromAppComponent', fromAppComponent);
		}
		params = params?.set('attributes', attributes);
		// params = params.set('attributes', attributes);
		return this.refreshVerifService.buidResult(
			this.httpClient.get<{ result: Partial<CashJournalModel[]>; refresh: boolean }>(`${this.BASE_URL}/find`, {
				params
			})
		);
	}

	getProjectByIndex(
		query,
		fromAppComponent: boolean,
		route: string,
		projectId: string
	): Observable<CashJournalModel> {
		let params;
		if (fromAppComponent) {
			params = new HttpParams()
				.set('fromAppComponent', fromAppComponent)
				.set('componentRoute', route)
				.set('projectId', projectId);
		} else {
			params = new HttpParams().set('fromAppComponent', fromAppComponent);
		}
		return this.refreshVerifService.buidResult(
			this.httpClient.post<CashJournalModel>(`${this.BASE_URL}/find-by-index`, { query }, { params })
		);
	}
	findByPagination(
		paginationOption: PaginationOption,
		fromAppComponent: boolean,
		route: string,
		projectId: string
	): Observable<PaginationData> {
		let params;
		if (fromAppComponent) {
			params = new HttpParams()
				.set('fromAppComponent', fromAppComponent)
				.set('componentRoute', route)
				.set('projectId', projectId);
		} else {
			params = new HttpParams().set('fromAppComponent', fromAppComponent);
		}
		return this.refreshVerifService.buidResult(
			this.httpClient.post<{ result: Partial<PaginationData>; refresh: boolean }>(
				`${this.BASE_URL}/find-by-pagination`,
				{ paginationOption },
				{ params }
			)
		);
	}

	findById(
		id?: string,
		fromAppComponent?: boolean,
		route?: string,
		projectId?: string
	): Observable<CashJournalModel> {
		let params;
		if (fromAppComponent) {
			params = new HttpParams()
				.set('fromAppComponent', fromAppComponent)
				.set('componentRoute', route)
				.set('projectId', projectId);
		} else {
			params = new HttpParams().set('fromAppComponent', fromAppComponent);
		}
		return this.refreshVerifService.buidResult(
			this.httpClient.get<CashJournalModel>(`${this.BASE_URL}/find-by-id/${id}`, { params })
		);
	}

	create(model: Partial<CashJournalModel>): Observable<Result> {
		return this.refreshVerifService.buidResult(this.httpClient.post<Result>(`${this.BASE_URL}/create`, model));
	}

	deposit(data: any): Observable<Result> {
		return this.refreshVerifService.buidResult(this.httpClient.post<Result>(`${this.BASE_URL}/deposit`, data));
	}

	edit(model: Partial<CashJournalModel>): Observable<Result> {
		return this.refreshVerifService.buidResult(this.httpClient.put<Result>(`${this.BASE_URL}/edit`, model));
	}
	editMultiple(models: Partial<CashJournalModel>[]): Observable<Result> {
		return this.refreshVerifService.buidResult(
			this.httpClient.put<Result>(`${this.BASE_URL}/edit-multiple`, models)
		);
	}

	delete(modelId: string): Observable<Result> {
		return this.refreshVerifService.buidResult(
			this.httpClient.delete<Result>(`${this.BASE_URL}/delete/${modelId}`)
		);
	}

	archive(modelId: string): Observable<Result> {
		return this.refreshVerifService.buidResult(
			this.httpClient.delete<Result>(`${this.BASE_URL}/archive/${modelId}`)
		);
	}

	isUsed(modelId: string): Observable<Result> {
		return this.refreshVerifService.buidResult(
			this.httpClient.get<Result>(`${this.BASE_URL}/if-is-Used/${modelId}`)
		);
	}
}
